import { render, staticRenderFns } from "./homologationInterBankAdd.vue?vue&type=template&id=18c3533a&scoped=true&"
import script from "./homologationInterBankAdd.vue?vue&type=script&lang=js&"
export * from "./homologationInterBankAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c3533a",
  null
  
)

export default component.exports